module.exports = __webpack_public_path__ + "static/media/carnaval.1177dff9.jpg";